// Reuse the byte formatter from coding-guidelines rather than re-deriving it: the two upload
// surfaces should format sizes identically, and this keeps a single source of truth.
export { formatFileSize } from '../coding-guidelines/coding-guidelines-types.ts'

// Freeform accepts ANY file — the whole point of the feature is "upload anything". The UI does not
// gate on extension: an allowlist here only drifts against what the backend extractor can actually
// read and refuses files it would have handled. The backend reports per file what it could not
// extract, which the activity view surfaces via parseStatus. The only client-side limit is a
// per-file size ceiling (total-corpus and file-count caps are enforced server-side).
export const FREEFORM_MAX_BYTES = 25 * 1024 * 1024
export const FREEFORM_MAX_FILES = 25

export const FREEFORM_ACCEPTED_HINT = 'Any file up to 25 MB each — pentest reports, scanner exports, notes'

// A file the user has selected but not yet submitted. `id` is a client-generated key so the chip list
// can be keyed and individual entries removed before submit (duplicate filenames are allowed).
export type StagedFile = {
  id: string
  file: File
}

export type FileRejection = {
  filename: string
  reason: string
}

export const validateFreeformFile = (file: File): string | undefined => {
  if (file.size > FREEFORM_MAX_BYTES) {
    return `"${file.name}" is larger than the allowed 25 MB per file.`
  }
  return undefined
}
